import { connect } from "react-redux";
import Select from "react-select";
import { industryOptions } from "../../config/IndustryOptions";
import { useRef } from "react";

const onboardingOptions = [{ label: "Onboarding by CS", value: "Onboarding by CS" }];

const CompanyDetailsFields = ({ data, updateField, jurisdiction, disabled, isAdmin }) => {
	const payeReferenceRef = useRef();
	const taxOfficeNoRef = useRef();

	console.debug(jurisdiction);

	return (
		<div className="form-container col-xs-12">
			<div className="form-material form-container">
				<input
					id="name"
					name="name"
					className="form-control form-input"
					value={data?.name}
					required="required"
					aria-required="true"
					disabled={disabled}
					onChange={(e) => {
						updateField(e.target.name, e.target.value);
					}}
				/>
				<label htmlFor="name">Business Name</label>
			</div>

			<div className="col-xs-4 pl-0">
				<div className="form-material form-container">
					<input
						id="phone"
						name="phone"
						className="form-control form-input"
						disabled={disabled}
						autoComplete="off"
						value={data?.phone}
						onChange={(e) => {
							updateField(e.target.name, e.target.value);
						}}
					/>
					<label htmlFor="phone">Telephone Number</label>
				</div>
			</div>
			<div className="col-xs-4 pl-0">
				<div className="form-material form-container">
					<input
						id="billingEmail"
						name="billingEmail"
						type="email"
						className="form-control form-input"
						disabled={disabled}
						autoComplete="off"
						value={data?.billingEmail}
						onChange={(e) => {
							updateField(e.target.name, e.target.value);
						}}
					/>
					<label htmlFor="billingEmail">Company Billing Email</label>
				</div>
			</div>
			<div className="col-xs-4 pl-0">
				<div className="form-material form-container">
					<Select
						name="industry"
						options={industryOptions}
						isDisabled={disabled}
						value={industryOptions.find((i) => i.value == data.industry)}
						placeholder="Choose one"
						onChange={(e) => {
							updateField("industry", e?.value || null);
						}}
					/>
					<label>Industry</label>
				</div>
			</div>

			{data?.jurisdiction == "UK" && (
				<div className="col-xs-4 pl-0">
					<div className="form-material form-container">
						<input
							id="aoReference"
							name="aoReference"
							className="form-control form-input"
							disabled={disabled}
							autoComplete="off"
							value={data?.aoReference}
							onChange={(e) => {
								updateField(e.target.name, e.target.value);
							}}
						/>
						<label htmlFor="aoReference">Accounts Office Reference</label>
					</div>
				</div>
			)}

			{data?.jurisdiction == "MT" && (
				<div className="col-xs-4 pl-0">
					<div className="form-material form-container">
						<input
							id="peNumber"
							name="peNumber"
							className="form-control form-input"
							disabled={disabled}
							autoComplete="off"
							value={data?.peNumber}
							onChange={(e) => {
								updateField(e.target.name, e.target.value);
							}}
						/>
						<label htmlFor="peNumber">P.E. Number</label>
					</div>
				</div>
			)}

			<div className="col-xs-4 pl-0">
				<div className="form-material form-container">
					<input
						id="vatNumber"
						name="vatNumber"
						className="form-control form-input"
						disabled={disabled}
						autoComplete="off"
						value={data?.vatNumber}
						onChange={(e) => {
							updateField(e.target.name, e.target.value);
						}}
					/>
					<label htmlFor="vatNumber">VAT</label>
				</div>
			</div>

			<div className="col-xs-4 pl-0">
				<div className="form-material form-container">
					<input
						id="taxNumber"
						name="taxNumber"
						className="form-control form-input"
						disabled={disabled}
						autoComplete="off"
						value={data?.taxNumber}
						onChange={(e) => {
							updateField(e.target.name, e.target.value);
						}}
					/>
					<label htmlFor="taxNumber">{data?.jurisdiction == "UK" ? "Corporation Tax" : "Tax Number"}</label>
				</div>
			</div>

			{data?.jurisdiction == "UK" ? (
				<>
					<div
						className="col-xs-6 pl-0 form-material"
						style={{ display: "flex" }}
					>
						<label>PAYE Reference</label>
						<input
							id="taxOfficeNo"
							name="taxOfficeNo"
							ref={taxOfficeNoRef}
							style={{ width: "25%", paddingRight: "2rem", display: "relative" }}
							className="form-control form-input"
							disabled={disabled}
							autoComplete="off"
							value={data?.taxOfficeNo}
							onChange={(e) => {
								updateField(e.target.name, e.target.value.substring(0, 3));
								if (e.target.value?.length >= 3) {
									payeReferenceRef.current.focus();
								}
							}}
						/>
						<div style={{ position: "absolute", top: 8, left: "20%" }}>/</div>
						<input
							id="payeRef"
							name="payeRef"
							ref={payeReferenceRef}
							style={{ width: "75%" }}
							className="form-control form-input"
							disabled={disabled}
							autoComplete="off"
							value={data?.payeRef}
							onChange={(e) => {
								updateField(e.target.name, e.target.value);
								if (!e.target.value.length) {
									taxOfficeNoRef.current.focus();
								}
							}}
						/>
					</div>
				</>
			) : null}
			<div className="col-xs-6 pl-0">
				<div className="form-material form-container">
					<input
						className="form-control form-input"
						id="companyNumber"
						name="companyNumber"
						onKey
						disabled={disabled}
						autoComplete="off"
						value={data?.companyNumber}
						onChange={(e) => {
							updateField(e.target.name, e.target.value);
						}}
					/>
					<label htmlFor="companyNumber">Company Number</label>
				</div>
			</div>

			{data?.jurisdiction == "MT" ? (
				<>
					<div className="col-xs-6 pl-0">
						<div className="form-material form-container">
							<input
								id="jobsplusNumber"
								name="jobsplusNumber"
								className="form-control form-input"
								disabled={disabled}
								autoComplete="off"
								value={data?.jobsplusNumber}
								onChange={(e) => {
									updateField(e.target.name, e.target.value);
								}}
							/>
							<label htmlFor="jobsplusNumber">Jobsplus Number</label>
						</div>
					</div>
				</>
			) : null}
			{isAdmin && (
				<div className="col-xs-6 pl-0">
					<div className="form-material form-container">
						<Select
							options={onboardingOptions}
							value={onboardingOptions.find((i) => i.value == data?.onboarding)}
							name="onboarding"
							isDisabled={disabled}
							isClearable={true}
							onChange={(e) => {
								updateField("onboarding", e?.value || null);
							}}
						/>
						<label>Onboarding Package</label>
					</div>
				</div>
			)}
			<div className="clearfix" />
			{jurisdiction != "UK" && (
				<>
					<div className="col-xs-6 pl-0">
						<div className="form-material form-container">
							<input
								id="principal"
								name="principal"
								className="form-control form-input"
								value={data.principal}
								disabled={disabled}
								autoComplete="off"
								onChange={(e) => {
									updateField(e.target.name, e.target.value);
								}}
							/>
							<label htmlFor="principal">Principal Name</label>
						</div>
					</div>

					<div className="col-xs-6 pl-0">
						<div className="form-material form-container">
							<input
								id="principalRole"
								name="principalRole"
								className="form-control form-input"
								disabled={disabled}
								autoComplete="off"
								value={data.principalRole}
								onChange={(e) => {
									updateField(e.target.name, e.target.value);
								}}
							/>
							<label htmlFor="principalRole">Principal Role</label>
						</div>
					</div>
				</>
			)}
			{/* <label className="css-input switch switch-sm switch-success">
                <input
                  id="allow-employees-to-update-details"
                  type="checkbox"
                  name="allowEmployees"
                  checked={allowEmployees}
                  className="update-company-settings"
                  ref={register}
                />
                <span />
                Allow employees to Update Details in Portal
              </label> */}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		isAdmin: state.my?.profile?.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetailsFields);
